import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { Operation } from '../_models/operation';
import { OperationsService } from '../_services/operations.service';
import { Subscription } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { MessService } from '../_services/mess-service.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';

@Component({
  selector: 'app-operations',
  templateUrl: './operations.component.html',
  animations: [
    trigger('rowExpansionTrigger', [
      state(
        'void',
        style({
          transform: 'translateX(-10%)',
          opacity: 0,
        })
      ),
      state(
        'active',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
    ]),
  ],
})
export class OperationsComponent implements OnInit, OnDestroy {
  operations: Operation[];
  loading: boolean = true;

  subscriptions: Subscription[] = [];

  constructor(
    private confirmationService: ConfirmationService,
    private messService: MessService,
    private operationsService: OperationsService,
    private router: Router,
    private authService: AuthenticationService
  ) {}

  // * Lifecycles === //
  ngOnInit() {
    this.updateOperationList();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  onDeleteOperation(event: Event, operationId: number) {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Da li ste sigurni da želite da obrišete operaciju?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.subscriptions.push(
          this.operationsService.deleteOperation(operationId).subscribe(
            () => {
              this.messService.add({
                severity: 'success',
                title: 'Uspešno brisanje',
                detail: 'Obrisali ste operaciju.',
              });
              this.updateOperationList();
            },
            (error) => {
              this.messService.add({
                severity: 'error',
                title: 'Greška',
                detail: 'Došlo je do greške, pokušajte ponovo!',
              });
            }
          )
        );
      },
    });
  }

  onEditOperation(operationData: Operation) {
    this.operationsService.updateOperationData.next(operationData);
  }

  private updateOperationList() {
    this.loading = true;
    this.subscriptions.push(
      this.operationsService.getAllOperations().subscribe((operations) => {
        this.operations = operations;
        this.loading = false;
      })
    );
  }
}
